import { 
  ATTR_STATUS, 
  ATTR_LAST_EDITED_TIME,
  ATTR_LAST_EDITED_TIME_STR,
  ATTR_SME_VERIFIED,
  VAL_STATUS_APPROVED,
  VAL_STATUS_AWAITING_APPROVAL,
 } from "../constants.js";

const getDateInMs = (d) => {
  let secOrMillisec = d;
  if (Math.abs(Date.now() - secOrMillisec) > Math.abs(Date.now() - secOrMillisec * 1000)) {
    secOrMillisec *= 1000;
  }
  return secOrMillisec;
}

const getDateDisplayStr = (d) => {
  try {
    const date = new Date(d);
    const str = `${date.toLocaleDateString("en-US", { day: 'numeric' })} ${  
      date.toLocaleDateString("en-US", { month: 'short' })} ${  
      date.toLocaleDateString("en-US", { year: 'numeric' })}`;
    return str;
  }
  catch (error) {}
}

const entityTransformer = (entityData) => {

  const entity = { ...entityData };

  // Ensure date fields are in milliseconds and add date display strings
  const timeToUse = entity[ATTR_LAST_EDITED_TIME];
  if (timeToUse) {
    entity[ATTR_LAST_EDITED_TIME] = getDateInMs(timeToUse);
    entity[ATTR_LAST_EDITED_TIME_STR] = getDateDisplayStr(getDateInMs(timeToUse));
  }

  // Decorate with SME verified status
  const statusToCheck = entity[ATTR_STATUS];
  const smev = (statusToCheck === VAL_STATUS_APPROVED) 
    || (statusToCheck === VAL_STATUS_AWAITING_APPROVAL);
  entity[ATTR_SME_VERIFIED] = smev;

  entity.id = entity.id || entity.exoveraId || entity.uuid || undefined;

  // Return transformed entity
  return entity;

}

export default entityTransformer;